var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list sngpc-ver" },
    [
      _c("grid-component", {
        attrs: {
          columns: _vm.gridColumns,
          conditionShowSubData: _vm.conditionShowSubData,
          data: _vm.gridData,
          extraSubActions: _vm.extraSubActions,
          showActionColumn: true,
          showEditItem: false,
          showRemoveItem: false,
          showExpand: true,
          showTableFoot: false,
          showTableHead: false,
          subColumns: _vm.gridColumnsVinculos,
          subDataName: _vm.subDataName,
          tituloPagina: "SNGPC Produtos",
        },
        on: {
          "change-sort": _vm.onChangeSort,
          "extra-sub-action": _vm.onExtraSubAction,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }